import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';


@Component({
  selector: 'pgs-front-pgs',
  templateUrl: './home-pgs.component.html',
  styleUrls: ['./home-pgs.component.scss']
})
export class HomePgsComponent implements OnInit {

  public searchForm: UntypedFormGroup;
  public searchBy: SearchBy;
  public advertisements: Advertisement[];
  public options: any[];

  constructor() {
    this.searchForm = new UntypedFormGroup({
      searchBy: new UntypedFormControl('RUT', [Validators.required]),
      searchValue: new UntypedFormControl('', [Validators.required])
    });
    this.searchBy = {
      rut: 'RUT',
      rutEmpresa: 'RUT Empresa',
      extranjero: 'Extranjero',
      numeroProyecto: 'Nº Proyecto',
      numeroSubproyecto: 'Nº Subproyecto',
    };
  }

  ngOnInit(): void {
    this.options = [
      { title: this.searchBy.rut, value: this.searchBy.rut },
      { title: this.searchBy.rutEmpresa, value: this.searchBy.rutEmpresa },
      { title: this.searchBy.extranjero, value: this.searchBy.extranjero },
      { title: this.searchBy.numeroProyecto, value: this.searchBy.numeroProyecto },
      { title: this.searchBy.numeroSubproyecto, value: this.searchBy.numeroSubproyecto },
    ];

    // TODO: service...
    this.advertisements = [
      {
        title: 'Contacto de jefes y supervisores ',
        paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit,'
        + ' sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        ago: 'hace 3 minutos',
      }, {
        title: 'Contacto de jefes y supervisores ',
        paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit,'
        + ' sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        ago: 'hace 10 minutos',
      }, {
        title: 'Contacto de jefes y supervisores ',
        paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit,'
        + ' sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        ago: 'hace 1 hora',
      }, {
        title: 'Contacto de jefes y supervisores ',
        paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit,'
        + ' sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        ago: 'hace 1 día',
      }
    ];
  }
}

interface SearchBy {
  rut: string;
  rutEmpresa: string;
  extranjero: string;
  numeroProyecto: string;
  numeroSubproyecto: string;
}

interface Advertisement {
  title: string;
  paragraph: string;
  ago: string;
}
